import data from "../schema/shared/sharedData";

const stateResolver = (id) => {
  const stateList = {
    1: "ALABAMA",
    2: "ALASKA",
    3: "ARIZONA",
    4: "ARKANSAS",
    5: "CALIFORNIA",
    6: "COLORADO",
    7: "CONNECTICUT",
    8: "DELAWARE",
    9: "DISTRICT OF COLUMBIA",
    10: "FLORIDA",
    11: "GEORGIA",
    12: "GUAM",
    13: "HAWAII",
    14: "IDAHO",
    15: "ILLINOIS",
    16: "INDIANA",
    17: "IOWA",
    18: "KANSAS",
    19: "KENTUCKY",
    20: "LOUISIANA",
    21: "MAINE",
    22: "MARYLAND",
    23: "MASSACHUSETTS",
    24: "MICHIGAN",
    25: "MINNESOTA",
    26: "MISSISSIPPI",
    27: "MISSOURI",
    28: "MONTANA",
    29: "NEBRASKA",
    30: "NEVADA",
    31: "NEW HAMPSHIRE",
    32: "NEW JERSEY",
    33: "NEW MEXICO",
    34: "NEW YORK",
    35: "NORTH CAROLINA",
    36: "NORTH DAKOTA",
    37: "OHIO",
    38: "OKLAHOMA",
    39: "OREGON",
    40: "PENNSYLVANIA",
    41: "PUERTO RICO",
    42: "RHODE ISLAND",
    43: "SOUTH CAROLINA",
    44: "SOUTH DAKOTA",
    45: "TENNESSEE",
    46: "TEXAS",
    47: "UTAH",
    48: "VERMONT",
    49: "VIRGIN ISLANDS",
    50: "VIRGINIA",
    51: "WASHINGTON",
    52: "WEST VIRGINIA",
    53: "WISCONSIN",
    54: "WYOMING",
    // 55: "AMERICAN SAMOA",
    // 56: "FEDERATED STATES OF MICRONESIA",
    // 57: "MARSHALL ISLANDS",
    58: "NORTHERN MARIANA ISLANDS",
    // 59: "PALAU",
    60: "ALBERTA",
    61: "BRITISH COLUMBIA",
    62: "MANITOBA",
    63: "NEW BRUNSWICK",
    64: "NEWFOUNDLAND AND LABRADOR",
    65: "NORTHWEST TERRITORIES",
    66: "NUNAVUT",
    67: "NOVA SCOTIA",
    68: "ONTARIO",
    69: "PRINCE EDWARD ISLAND",
    70: "QUEBEC",
    71: "SASKATCHEWAN",
    72: "YUKON",
  };
  return stateList[id] || "NORTHERN MARIANA ISLANDS";
};

export const stateAbbreviationResolver = (id) => {
  const stateList = {
    AL: "ALABAMA",
    AK: "ALASKA",
    AZ: "ARIZONA",
    AR: "ARKANSAS",
    CA: "CALIFORNIA",
    CO: "COLORADO",
    CT: "CONNECTICUT",
    DE: "DELAWARE",
    DC: "DISTRICT OF COLUMBIA",
    FL: "FLORIDA",
    GA: "GEORGIA",
    GU: "GUAM",
    HI: "HAWAII",
    ID: "IDAHO",
    IL: "ILLINOIS",
    IN: "INDIANA",
    IA: "IOWA",
    KS: "KANSAS",
    KY: "KENTUCKY",
    LA: "LOUISIANA",
    ME: "MAINE",
    MD: "MARYLAND",
    MA: "MASSACHUSETTS",
    MI: "MICHIGAN",
    MN: "MINNESOTA",
    MS: "MISSISSIPPI",
    MO: "MISSOURI",
    MT: "MONTANA",
    NE: "NEBRASKA",
    NV: "NEVADA",
    NH: "NEW HAMPSHIRE",
    NJ: "NEW JERSEY",
    NM: "NEW MEXICO",
    NY: "NEW YORK",
    NC: "NORTH CAROLINA",
    ND: "NORTH DAKOTA",
    OH: "OHIO",
    OK: "OKLAHOMA",
    OR: "OREGON",
    PA: "PENNSYLVANIA",
    PR: "PUERTO RICO",
    RI: "RHODE ISLAND",
    SC: "SOUTH CAROLINA",
    SD: "SOUTH DAKOTA",
    TN: "TENNESSEE",
    TX: "TEXAS",
    UT: "UTAH",
    VT: "VERMONT",
    VI: "VIRGIN ISLANDS",
    VA: "VIRGINIA",
    WA: "WASHINGTON",
    WV: "WEST VIRGINIA",
    WI: "WISCONSIN",
    WY: "WYOMING",
    // AS: "AMERICAN SAMOA",
    // FSM: "FEDERATED STATES OF MICRONESIA",
    // MH: "MARSHALL ISLANDS",
    MP: "NORTHERN MARIANA ISLANDS",
    // PW: "PALAU",
    AB: "ALBERTA",
    BC: "BRITISH COLUMBIA",
    MB: "MANITOBA",
    NB: "NEW BRUNSWICK",
    NL: "NEWFOUNDLAND AND LABRADOR",
    NT: "NORTHWEST TERRITORIES",
    NU: "NUNAVUT",
    NS: "NOVA SCOTIA",
    ON: "ONTARIO",
    PE: "PRINCE EDWARD ISLAND",
    QC: "QUEBEC",
    SK: "SASKATCHEWAN",
    YT: "YUKON",
  };
  if (!!data.state.includes(id)) {
    return id;
  }
  return stateList[id] || undefined;
};

export default stateResolver;
